import { render, staticRenderFns } from "./attendanceRecord.vue?vue&type=template&id=b8657f66&"
import script from "./attendanceRecord.vue?vue&type=script&lang=ts&"
export * from "./attendanceRecord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports